<template>
  <div class="container">
    <!-- <div class="notice-box1" v-if="isShowNotify && noticeInfo && noticeInfo.length > 0">
      <div class="left-text line_right">公告</div>
      <div class="swiper-box" @click="goNotifyPage">
        <annoswiper :dataList="noticeInfo"></annoswiper>
      </div>
    </div> -->
    <div class="pg-pd12" :style="{ 'padding-top': isShowNotify ? '19px' : '24px' }">
      <div class="prov-total">
        <div class="prov-total-sel">
          <div v-if="!isProvPriv || userInfo.areaLevel !== '1'" class="select">
            <span>{{ cityName }}</span>
          </div>
          <div v-else class="select" @click="handleCityPickerShow()">
            <span>{{ cityName }}</span>
            <div class="select-icon"></div>
          </div>
          <div class="select" @click="handleQuarterPickerShow()">
            <span>{{ quarterName }}</span>
            <div class="select-icon"></div>
          </div>
        </div>

        <div class="content">
          <div class="content-item">
            <!--省与州市都显示-->
            <div class="total">
              <scoreCard :type="1" :data="assessment"></scoreCard>
            </div>
            <!-- 是州市时显示 -->
            <!-- <div v-if="!isProvPriv" class="total" @click="navToRank()">
              <scoreCard :type="2" :data="assessment"></scoreCard>
            </div> -->
          </div>
          <!-- <div style="height:300px; margin-bottom:24px;" v-if="doubleData && doubleData.length > 0">
            <doubleLineCharts :doubleData="doubleData"></doubleLineCharts>
          </div> -->
          <!-- <div style="height:300px; margin-bottom:24px;" v-else>
            <doubleLineCharts :doubleData="doubleData"></doubleLineCharts>
          </div> -->
          <!-- <div style="height:300px; margin-bottom:24px;">
            <doubleLineCharts :doubleData="doubleData"></doubleLineCharts>
          </div> -->
        </div>
      </div>
      <div class="prov-total">
        <!-- <tab class="mt0" :tabList="dataTab" :name="'dataTab'" @onSwitch="tabSwitch"></tab> -->
        <!-- 没有时间。tab隐藏-->
        <!-- <div class="prov-title">考评得分</div> -->
        <div class="content" v-if="detailList.length">
          <!--有tab时加上 mt20-->
          <!-- 按类型 -->
          <div class="content-pd16" v-show="curIndex == 0">
            <!-- <div class="com-box">
              <div class="com-box-left">
                <div>对比上季度</div>
                <van-switch v-model="isOpen" active-color="#07c160" inactive-color="#E4E4E5" />
              </div>
            </div> -->
            <evolve :listData="detailList" :isOpen="isOpen" :year="year" @navToScoreList="navToScoreList"></evolve>
          </div>
          <!-- 按时间 -->
          <!-- <div class="time-cont" v-show="curIndex == 1">
            <timeList :listData="timeList"></timeList>
          </div> -->
        </div>
        <!-- 没有数据提示 -->
        <div v-else class="noData-bg">
          <nodata :noData="noData"></nodata>
        </div>
      </div>
    </div>
    <common-picker v-if="showAreaPicker" ref="commonPickerQuarter" :typeList="quarterList"
      :pickerDefaultValue="[quarterName]" :cols="1" @getTypeValue="handleQuarterChange"></common-picker>
    <common-picker v-if="isProvPriv == 1 && showQuarterPicker" ref="commonPickerCity" :typeList="cityList"
      :pickerDefaultValue="[cityName]" :cols="1" @getTypeValue="handleCityChange"></common-picker>
  </div>
</template>
<script>
import nodata from "../components/nodata"; // 没有数据
import evolve from "../components/evolve";
import timeList from "../components/timeList";
import scoreCard from "../components/score-card";
import tab from "comps/tab";
import doubleLineCharts from "../../../components/DoubleLineCharts"; //双折线
import commonPicker from "../../../components/base/commonPicker"; // 选择季度
// import errorPage from './components/refresh';
import api from "../../../service/modules/appraise";

import annoswiper from "./../components/anno-swiper";
import API from "../../../service/index";
import commonAPI from "../../../utils/common";
import util from "../../../utils/common";
import { ASSESS_TYPE } from '../config/constants';

const noData = {
  title: "暂无数据",
};
const userInfo = commonAPI.getJsonLocal("appraiseNewLocalauthority") || {};

const column2018 = [

  {
    title: "落实领导责任（3分）",
    key: "leaderResponPrac",
    totalScore: 300
  },
  {
    title: "综合监管模式（7分）",
    key: "unitMonitorMode",
    totalScore: 700
  },
  {
    title: "涉旅有效投诉办结情况（4分）",
    key: "tripCaseDone",
    totalScore: 400
  },
  {
    title: "涉旅有效投诉立案查处情况（3分）",
    key: "tripCaseDeal",
    totalScore: 300
  },
  {
    title: "涉旅督办案件结案情况（3分）",
    key: "tripCaseClosed",
    totalScore: 300
  },
  {
    title: "负面舆情（10分）",
    key: "badOpinion",
    totalScore: 1000
  },
  {
    title: "安全生产（10分）",
    key: "accident",
    totalScore: 1000
  },
  {
    title: "受处理情况（10分）",
    key: "punished",
    totalScore: 1000
  },
  {
    title: "团队游客投诉情况（15分）",
    key: "teamTouristComplain",
    totalScore: 1500
  },
  {
    title: "散客投诉情况（15分）",
    key: "indiviTouristComplain",
    totalScore: 1500
  },
  {
    title: "游客满意度情况（20分）",
    key: "expSatisfyScore",
    totalScore: 2000
  },
];
// 2019-2022
const column2022 = [
  {
    title: "综合监管模式运行情况（6分）",
    totalScore: 600,
    key: "scoreA",
  },
  {
    title: "“1+16+129+X”游客投诉处置体系运行情况（3分）",
    totalScore: 300,
    key: "scoreB",
  },
  {
    title: "涉旅企业诚信评价进展情况（13分）",
    totalScore: 1300,
    key: "scoreC",
  },
  {
    title: "涉旅安全事故发生情况得分（10分）",
    totalScore: 1000,
    key: "safetyAccidents",
  },
  {
    title: "受到上级通报批评、约谈、问责等处理情况（10分）",
    totalScore: 1000,
    key: "scoreD",
  },
  {
    title: "发生涉旅负面舆情情况得分（10分）",
    totalScore: 1000,
    key: "negativeOpinion",
  },
  {
    title: "游客投诉率（9分）",
    totalScore: 900,
    key: "scoreF",

  },
  {
    title: "游客投诉处置效率（9分）",
    totalScore: 900,
    key: "scoreG",
  },
  {
    title: "游客投诉处置满意度（20分）",
    totalScore: 2000,
    key: "scoreH",

  },
  {
    title: "游客体验满意度（10分）",
    totalScore: 1000,
    key: "scoreI",
  },

];

const AUTHORITY = [
  "audit",
  "manager",
  "input",

]

// 2023 
const column2023 = [
  {
    title: "综合监管模式完善运行情况（20分）",
    totalScore: 2000,
    key: "scoreA",
    assessType: "A",
    authority: [...AUTHORITY,]
  },
  {
    title: "“1+16+129+X”游客投诉处置体系运行情况（6分）",
    totalScore: 600,
    key: "scoreB",
    assessType: "B",
    authority: [...AUTHORITY, "refund"]
  },
  {
    title: "涉旅企业诚信评价进展情况（10分）",
    totalScore: 1000,
    key: "scoreC",
    assessType: "C",
    authority: [...AUTHORITY, "enterManage"]
  },
  {
    title: "涉旅安全事故发生情况得分（10分）",
    key: "safetyAccidents",
    assessType: "D",
    totalScore: 1000,
    authority: [...AUTHORITY, "marketManage"]
  },
  {
    title: "受到上级问责、约谈、通报批评、警告、整改、取消等情况（7分）",
    totalScore: 700,
    key: "scoreD",
    assessType: "E",
    authority: [...AUTHORITY,]
  },
  {
    title: "发生涉旅负面舆情情况得分（10分）",
    key: "negativeOpinion",
    assessType: "F",
    totalScore: 1000,
    authority: [...AUTHORITY, "badOpinion"]
  },

  {
    title: "游客投诉增长率得分（15分）",
    key: "scoreL",
    assessType: "L",
    totalScore: 1500,
    authority: [...AUTHORITY, "complaint"]
  },

  {
    title: "游客投诉处置效率（6分）",
    key: "scoreG",
    assessType: "H",
    totalScore: 600,
    authority: [...AUTHORITY, "complaint"]
  },

  {
    title: "游客投诉处置满意度（10分）",
    key: "scoreH",
    assessType: "I",
    totalScore: 1000,
    authority: [...AUTHORITY, "complaint"]
  },
  {
    title: "30天无理由退货（6分）",
    totalScore: 600,
    key: "scoreK",
    assessType: "K",
    authority: [...AUTHORITY, "refund"]
  },
];

export default {
  name: "provincialDetail",
  components: {
    scoreCard,
    tab,
    evolve,
    timeList,
    doubleLineCharts,
    commonPicker,
    nodata,
    annoswiper,
    // errorPage
  },

  data() {
    return {
      getData: false,
      noData, // 无数据展示文本
      userInfo, // 用户数据
      quarterList: [], // 季度列表
      cityList: [], // 城市列表
      noticeInfo: [],
      isShowNotify: false, // 是否展示公告
      showAreaPicker: false,
      showQuarterPicker: false,
      isOpen: false, // 是否对比季度
      isProvPriv:
        this.$route.query.isProvPriv || Number(userInfo.areaLevel === "1"), // 是否省级
      dataTab: ["按类型", "按时间"],
      // 双折线图
      doubleData: [],
      assessment: {
        title: "考核分",
        num: 0,
        diff: "",
      },
      detailList: [], // 按类型
      timeList: [], // 按时间
      areaInfo: {},
      // areaType: 1,
      detailInfo: {},
      complainQuarter: "",
      isShow: false,
      showBack: false,
      // 年  季度  城市 参数
      year: "",
      quarter: "",
      quarterName: "",
      cityCode: userInfo.area || "530000",
      cityName: userInfo.areaName || "云南省",
      curIndex: 0,
    };
  },
  watch: {
    cityList: {
      handler(val) {
        this.showQuarterPicker = false;
        this.$nextTick(() => {
          this.showQuarterPicker = true;
        });
      },
    },
    quarterList: {
      handler(val) {
        this.showAreaPicker = false;
        this.$nextTick(() => {
          this.showAreaPicker = true;
        });
      },
    },
  },

  created() {
    console.log('output->[ detail created ] >', this.$route.query)
    this.year = this.$route.query.year;
    this.quarter = this.$route.query.quarter;
    this.cityCode = this.$route.query.area;
    this.quarterName = this.$route.query.year + '年' + this.fixQuater(this.$route.query.quarter);
    // this.getInit()
    //按类型获取全部数据
    this.initData("1", "A");
    // if (this.$route.query.isProvPriv == 1) {
    //   this.year = this.$route.query.year;
    //   this.quarter = this.$route.query.quarter;
    //   this.cityCode = this.$route.query.area;
    //   this.cityName = this.$route.query.uuuuxd == 1 ? decodeURIComponent(this.$route.query.areaName) : this.$route.query.areaName;
    //   this.quarterName = this.$route.query.uuuuxd == 1 ? this.$route.query.year + '年' + this.fixQuater(this.$route.query.quarter) : this.$route.query.quarterName;
    //   this.complainQuarter = this.$route.query.complainQuarter;
    //   this.showAreaPicker = this.$route.query.compickFlag;
    //   this.showQuarterPicker = this.$route.query.compickFlag2;
    //   // console.log('-----判断数据类型:', typeof this.$route.query.isShowTopnofify);
    //   if (typeof this.$route.query.isShowTopnofify == "string") {
    //     if (
    //       !this.$route.query.isShowTopnofify ||
    //       this.$route.query.isShowTopnofify == "false"
    //     ) {
    //       this.isShowNotify = false;
    //     } else {
    //       this.isShowNotify = true;
    //     }
    //   } else {
    //     this.isShowNotify = this.$route.query.isShowTopnofify;
    //   }
    // }
    // else{
    //   const params = commonAPI.getJsonLocal("onlyonlyreadone");
    //   if( params){
    //     this.year = params.year;
    //     this.quarter = params.quarter;
    //     this.cityCode = params.area;
    //     this.cityName = params.areaName;
    //     this.quarterName = params.year + '年' + this.fixQuater(params.quarter);
    //     this.complainQuarter = params.complainQuarter;
    //     this.showAreaPicker = params.compickFlag;
    //     this.showQuarterPicker = params.compickFlag2;
    //   }
    // }

    // 初始化页面数据
    // this.initData();
  },
  mounted() {
    console.log("----是否执行生命周期函数");
    // this.initData("1", "A");
  },
  methods: {
    getInit() {
      if (this.$route.query.isProvPriv == 1) {
        this.year = this.$route.query.year;
        this.quarter = this.$route.query.quarter;
        this.cityCode = this.$route.query.area;
        this.cityName = this.$route.query.uuuuxd == 1 ? decodeURIComponent(this.$route.query.areaName) : this.$route.query.areaName;
        this.quarterName = this.$route.query.uuuuxd == 1 ? this.$route.query.year + '年' + this.fixQuater(this.$route.query.quarter) : this.$route.query.quarterName;
        this.complainQuarter = this.$route.query.complainQuarter;
        this.showAreaPicker = this.$route.query.compickFlag;
        this.showQuarterPicker = this.$route.query.compickFlag2;
        // console.log('-----判断数据类型:', typeof this.$route.query.isShowTopnofify);
        if (typeof this.$route.query.isShowTopnofify == "string") {
          if (
            !this.$route.query.isShowTopnofify ||
            this.$route.query.isShowTopnofify == "false"
          ) {
            this.isShowNotify = false;
          } else {
            this.isShowNotify = true;
          }
        } else {
          this.isShowNotify = this.$route.query.isShowTopnofify;
        }
      }
      else {
        const params = commonAPI.getJsonLocal("onlyonlyreadone");
        if (params) {
          this.year = params.year;
          this.quarter = params.quarter;
          this.cityCode = params.area;
          this.cityName = params.areaName;
          this.quarterName = params.year + '年' + this.fixQuater(params.quarter);
          this.complainQuarter = params.complainQuarter;
          this.showAreaPicker = params.compickFlag;
          this.showQuarterPicker = params.compickFlag2;
        }
      }
      //TODO 要是年份和季度没有传递的话，默认查询上个季度
      // if (this.getData) this.getAssessScoreDay(1, 'A')

      this.fetchCityAssess()
    },
    fixQuater(index) {
      if (index == 1) {
        return "第一季度";
      } else if (index == 2) {
        return "第二季度";
      } else if (index == 3) {
        return "第三季度";
      } else if (index == 4) {
        return "第四季度";
      }
    },
    /**
     * @description: 初始化数据和城市、季度、类型切换的数据请求
     * @param { num } Number 0：按类型部分数据，1：按类型的全量数据（对比上季度数据）
     * @param {type} A：按类型，B： 按时间
     */
    async initData(num, type) {
      if (this.quarterList.length == 0) {
        this.getnotify(); // 获取公告
        await this.getCityList(); // 城市列表
        await this.getQuater(); // 季度列表
      }

      if (!this.year) {
        const defaultQuarter = this.quarterList[0][0];
        const dateArr = defaultQuarter.code.split("-");
        this.year = dateArr[0];
        this.quarter = dateArr[1];
        this.quarterName = defaultQuarter.text;
      }
      // await this.getAssessScoreDay(num, type); // 获取页面数据

      this.fetchCityAssess()
    },

    async fetchCityAssess() {
      if (this.year == 2018) {
        // 2018
        await this.findTourismAppraisalResult()
      } else {
        await this.getAfter2019TableData()
      }
    },

    findTourismAppraisalResult() {
      const _this = this;
      return new Promise((resolve, reject) => {
        API.findTourismAppraisalResult({
          year: this.year,
          quarter: this.quarter,
        }).then((res) => {
          _this.detailList = [];

          if (res.ret || !res.data) {
            _this.assessment = {
              title: "考核分",
              num: "0",
              diff: "-",
              title2: "考核排名",
              ranking: "0",
            };
            _this.detailList = [];
            reject()
            return;
          }

          let findCityAccess = res.data.find((item) => item.area == _this.cityCode)
          if (findCityAccess) {
            _this.assessment = {
              title: "考核分",
              num: `${findCityAccess.totalScore / 100}`,
              diff: "-",
              title2: "考核排名",
              ranking: findCityAccess.ranking,
            };
            _this.detailList = column2018.map(item => _this.mapperItem(item, findCityAccess))
            console.log('output->[ this.detailList ] >', _this.detailList)
          } else {
            _this.assessment = {
              title: "考核分",
              num: "0",
              diff: "-",
              title2: "考核排名",
              ranking: "0",
            };
            _this.detailList = [];

          }
          resolve()

        })
      });
    },
    getAfter2019TableData() {
      const _this = this;
      return new Promise((resolve, reject) => {
        API.findRegulatoryCheckResult({
          year: this.year,
          quarter: this.quarter,
        }).then((res) => {
          _this.detailList = [];

          if (res && res.data && (res.data.oneAssessScoreList.length != 0 || res.data.twoAssessScoreList.length != 0)) {
            let showAll = res.data.showAll
            let allList = []
            let colunmList = column2022
            if (showAll == 0) {
              allList = res.data.oneAssessScoreList.concat(res.data.twoAssessScoreList)
            }
            if (showAll == 1) {
              allList = res.data.all;
              colunmList = column2023
            }
            let findCityAccess = allList.find((item) => item.area == this.cityCode)
            if (findCityAccess) {
              this.assessment = {
                title: "考核分",
                num: `${findCityAccess.totalScore / 100}`,
                diff: "-",
                title2: "考核排名",
                ranking: findCityAccess.sort,
              };
              this.detailList = colunmList.map(item => _this.mapperItem(item, findCityAccess))
              console.log('output->[ this.detailList ] >', this.detailList)
            } else {
              this.assessment = {
                title: "考核分",
                num: "0",
                diff: "-",
                title2: "考核排名",
                ranking: "0",
              };
              this.detailList = [];

            }
            resolve()
          } else {
            this.assessment = {
              title: "考核分",
              num: "0",
              diff: "-",
              title2: "考核排名",
              ranking: "0",
            };
            this.detailList = [];
            reject()
          }



        })
      });
    },
    mapperItem(item, scoreMap) {
      let score = scoreMap[item.key];
      const { userRole, areaLevel, area } = userInfo;
      return {
        totalScore: Number(item.totalScore) / 100,
        projectName: item.title,
        deduction: (item.totalScore - score) / 100,
        score: Number(score) / 100,
        //权限控制
        clickBtn: item.authority?.includes(userRole) || false,
        assessType: item.assessType,
      };
    },
    // 获取页面全部数据
    getAssessScoreDay(contrast, type) {
      const _this = this;
      return new Promise((resolve, reject) => {
        API.getAssessScoreDay({
          year: this.year,
          quarter: this.quarter,
          area: this.cityCode,
          contrast: contrast,
          type: type,
        }).then((res) => {
          _this.timeList = [];
          _this.doubleData = [];
          _this.detailList = [];

          if (res.ret || !res.data) {
            this.assessment = {
              title: "考核分",
              num: "0",
              diff: "-",
              title2: "考核排名",
              ranking: "0",
              rankingChange: "-",
            };
            this.doubleData = [];
            this.detailList = [];
            this.timeList = [];
            return;
          }
          setTimeout(() => {
            const {
              scoreAndRankingVO, // 考核分数信息
              deductionResVO, // 按类型
              chartVO, //  图表信息
              timeList, // 按时间
            } = res.data;
            // 考核分数据
            this.assessment = {
              title: "考核分",
              num: scoreAndRankingVO.score,
              diff: scoreAndRankingVO.scoreChange,
              title2: "考核排名",
              ranking: scoreAndRankingVO.ranking,
              rankingChange: scoreAndRankingVO.rankingChange,
            };
            // let temChart = [{
            //     "score": "70.04",
            //     "ranking": 4,
            //     "recordTime": "2020-09-29"
            //   }, {
            //     "score": "50.54",
            //     "ranking": 5,
            //     "recordTime": "2020-09-20"
            //   }, {
            //     "score": "73.85",
            //     "ranking": 5,
            //     "recordTime": "2020-09-10"
            //   },{
            //     "score": "62.66",
            //     "ranking": 2,
            //     "recordTime": "2020-08-20"
            //   },{
            //     "score": "58.25",
            //     "ranking": 5,
            //     "recordTime": "2020-08-01"
            //   }, {
            //     "score": "58.4",
            //     "ranking": 2,
            //     "recordTime": "2020-07-20"
            //   }, {
            //     "score": "58.5",
            //     "ranking": 1,
            //     "recordTime": "2020-07-16"
            //   }, {
            //     "score": "73.85",
            //     "ranking": 5,
            //     "recordTime": "2020-09-10"
            //   },{
            //     "score": "62.66",
            //     "ranking": 2,
            //     "recordTime": "2020-08-20"
            //   },{
            //     "score": "58.25",
            //     "ranking": 5,
            //     "recordTime": "2020-08-01"
            //   }, {
            //     "score": "58.4",
            //     "ranking": 2,
            //     "recordTime": "2020-07-20"
            //   },]
            // 折线图数据  chartVO
            this.doubleData = chartVO.map((item) => {
              return {
                xAxis: item.recordTime,
                left: item.score,
                right: item.ranking,
              };
            });
            // 按类型 按时间  排序
            if (deductionResVO) {
              deductionResVO.sort((x, y) => {
                var valueN = x.assessType;
                var valueM = y.assessType;
                if (valueN < valueM) return -1;
                else if (valueN > valueM) return 1;
                else return 0;
              });
            }
            const authlist = commonAPI.getAuthorityList("ASSESS_SCORE");
            console.log("------权限集合", authlist);
            if (authlist && authlist.length > 0) {
              // 按类型
              this.detailList = [];
              if (deductionResVO && deductionResVO.length > 0) {
                for (let i = 0; i < deductionResVO.length; i++) {
                  for (let j = 0; j < authlist.length; j++) {
                    if (authlist[j].assessType === deductionResVO[i].assessType) {
                      deductionResVO[i].clickBtn = true;
                      if (userInfo && userInfo.areaLevel === '1') {
                        console.log('全部展示:', userInfo && userInfo.areaLevel)
                        // 省级权限全部展示, 匹配到的才能进详情
                        this.detailList = deductionResVO;
                      } else {
                        console.log('匹配权限展示:', userInfo && userInfo.areaLevel)
                        // 其他权限只有匹配等到的才展示
                        this.detailList.push(deductionResVO[i]);
                      }
                      // console.log(this.detailList, '-----')
                    }
                  }
                }
                // console.log('按类型数据:', this.detailList);
              } else {
                this.detailList = [];
              }
              // 按时间
              if (timeList && timeList.length > 0) {
                for (let i = 0; i < timeList.length; i++) {
                  for (let j = 0; j < authlist.length; j++) {
                    if (
                      timeList[i].coseType.indexOf(authlist[j].assessType) > -1
                    ) {
                      this.timeList.push(timeList[i]);
                    }
                  }
                }
              } else {
                this.timeList = [];
              }
            }
          }, 3);

          // this.detailList = deductionResVO;
          // console.log("-----按类型数据:", deductionResVO);
          // this.timeList = timeList;
        });
      });
    },
    // 获取通知公告
    getnotify() {
      API.getNotify({}).then((res) => {
        if (res.ret == 0) {
          this.noticeInfo = res.data;
        }
      });
    },
    // 选择季度
    handleQuarterChange(value) {
      this.quarterName = value[0].text;
      // console.log("----季度的code:", value[0].code);
      this.year = value[0].code.split("-")[0]; // 取年
      this.quarter = value[0].code.split("-")[1]; // 取季度
      this.complainQuarter = value[0].complainQuarter;
      /** 执行tab 切换方法，传入当前的索引 **/
      this.tabSwitch(this.curIndex);
    },
    // 选择州市
    handleCityChange(value) {
      console.log(value);
      this.cityName = value[0].text;
      this.cityCode = value[0].area;
      /** 执行tab 切换方法，传入当前的索引 **/
      this.tabSwitch(this.curIndex);
    },
    // 获取季度
    getQuater() {
      return new Promise((resolve, reject) => {
        this.quarterList = []
        API.getQuarters({}).then((res) => {
          if (res.ret == 0) {
            let temList = [];
            for (let i = 0; i < res.data.length; i++) {
              for (let key in res.data[i]) {
                let obj = {
                  text: res.data[i][key],
                  code: key,
                };
                temList.push(obj);
              }
            }
            temList.reverse();
            // console.log("------员：", temList[0].code);
            // this.year = temList[0].code.substring(0, 4);
            // this.quarter = temList[0].code.substring(5);
            this.quarterList.push(temList);
            resolve(true);
          }
        });
      });
    },
    // 获取城市列表
    getCityList() {
      return new Promise((resolve, reject) => {
        this.cityList = []
        API.getCityList({}).then((res) => {
          if (res.ret == 0) {
            if (
              res.data &&
              res.data.oneAreaTypeResVO &&
              res.data.twoAreaTypeResVO
            ) {
              let temCity = [];
              for (let i = 0; i < res.data.oneAreaTypeResVO.length; i++) {
                let obj = {
                  text: res.data.oneAreaTypeResVO[i].areaName,
                  code: res.data.oneAreaTypeResVO[i].sysCode,
                  area: res.data.oneAreaTypeResVO[i].area,
                };
                temCity.push(obj);
              }
              for (let i = 0; i < res.data.twoAreaTypeResVO.length; i++) {
                let obj = {
                  text: res.data.twoAreaTypeResVO[i].areaName,
                  code: res.data.twoAreaTypeResVO[i].sysCode,
                  area: res.data.twoAreaTypeResVO[i].area,
                };
                temCity.push(obj);
              }
              let findCity =  temCity.find(item=>item.area == this.cityCode)
              if(findCity){
                this.cityName = findCity.text
              }
              this.cityList.push(temCity);
              resolve(true);
            } 
          }
        });
      });
    },
    // 跳转公告页面
    goNotifyPage() {
      this.$router.push({ path: "/appraise/announcement" });
    },
    // 考核类型跳转, id, directDetail, assessType
    navToScoreList(row) {
      console.log("------进10大项：", row);
      const { areaName } = util.getJsonLocal("appraiseNewLocalauthority");
      let queryObj = {
        area: this.cityCode,
        year: Number(this.year),
        quarter: this.quarter,
        areaName: this.cityName ? this.cityName : areaName,
        quarterName: this.quarterName,
        ...row,
        // assessName: row.projectName,
        assessName:row.projectName.replace(/\（.*?\）/g, ""),
        // deduction: row.deduction,
        // lastScore: row.lastScore,
        // score: row.score,
        // scoreChange: row.scoreChange,
        // totalScore: row.totalScore
      };
      console.log("---首页详情路由跳转值:", queryObj);
      if (row.assessType === "A") {
        this.$router.push({
          path: "/appraise/deduction_list",
          query: queryObj,
        });
      } else if (row.assessType === "B") {
        // this.$router.push({
        //   path: "/appraise/oprationSituation",
        //   query: queryObj,
        // });
        this.$router.push({
          path: "/appraise/assessB",
          query: queryObj,
        });
      } else if (row.assessType === "C") {
        this.$router.push({
          path: "/appraise/creditList",
          query: queryObj,
        });
      } else if (row.assessType === "D") {
        this.$router.push({
          path: "/appraise/travelAccident",
          query: queryObj,
        });
      } else if (row.assessType === "E") {
        this.$router.push({
          path: "/appraise/notificationList",
          query: queryObj,
        });
      } else if (row.assessType === "F") {
        this.$router.push({
          path: "/appraise/negativeList",
          query: queryObj,
        });
        // this.$router.push({ path: '/appraise/batchReview'})
      } else if (row.assessType === "L") {  // 游客投诉增长率
        queryObj["totalScore"] = row.totalScore;
        queryObj["score"] = row.score;
        // this.$router.push({ 
        //   path: "/appraise/touristComplain",
        //   query: queryObj,
        // });
        this.$router.push({
          path: "/appraise/touristComplainIncresRate",
          query: queryObj,
        });
      } else if (row.assessType === "H") { // ✅
        queryObj["totalScore"] = row.totalScore;
        queryObj["score"] = row.score;
        // this.$router.push({
        //   path: "/appraise/complainDispose",
        //   query: queryObj,
        // });
        this.$router.push({
          path: "/appraise/touristComplainHandleSatisfaction",
          query: queryObj,
        });
      } else if (row.assessType === "I") { // ✅
        queryObj["totalScore"] = row.totalScore;
        queryObj["score"] = row.score;
        this.$router.push({
          path: "/appraise/touristDispose",
          query: queryObj,
        });
      } else if (row.assessType === "J") { //游客体验满意度考核项
        this.$router.push({
          path: "/appraise/touristExperience",
          query: queryObj,
        });
      } else if (row.assessType === "K") { //30天无理由退货
        this.$router.push({
          path: "/appraise/assessK",
          query: queryObj,
        });
      }
    },
    handleQuarterPickerShow() {
      this.showAreaPicker = true;
      this.$refs.commonPickerQuarter.showPicker();
    },
    handleCityPickerShow() {
      this.showQuarterPicker = true;
      this.$refs.commonPickerCity.showPicker();
    },
    // 跳转查看评分细则
    // navTo() {
    //   this.$router.push({
    //     path: "/appraise/scoringList",
    //     query: {}
    //   });
    // },
    // 跳转查看州市排名
    navToRank() {
      this.$router.push("/appraise/rankList");
    },
    // 切换按类型 与 按时间， 渲染时会在组件中执行一次，这里执行 getAssessScoreDay 就行了，不用在 initData 中再执行一次
    async tabSwitch(index) {
      this.curIndex = index;
      if (index == 0) {
        this.initData("1", "A");
      } else {
        this.initData("0", "B");
      }
    },
    // 检查是否有有权限访问扣分子项或者详情
    checkHasAuthority() {

    },
  },
  activated() {
    console.log('----什么时候走这个?activated');
    // if (this.$route.query.isProvPriv == 1) {
    //   this.year = this.$route.query.year;
    //   this.quarter = this.$route.query.quarter;
    //   this.cityCode = this.$route.query.area;
    //   this.cityName = this.$route.query.uuuuxd == 1 ? decodeURIComponent(this.$route.query.areaName) : this.$route.query.areaName;
    //   this.quarterName = this.$route.query.uuuuxd == 1 ? this.$route.query.year + '年' + this.fixQuater(this.$route.query.quarter) : this.$route.query.quarterName;
    //   this.complainQuarter = this.$route.query.complainQuarter;
    //   this.showAreaPicker = this.$route.query.compickFlag;
    //   this.showQuarterPicker = this.$route.query.compickFlag2;
    //   // console.log('-----判断数据类型:', typeof this.$route.query.isShowTopnofify);
    //   if (typeof this.$route.query.isShowTopnofify == "string") {
    //     if (
    //       !this.$route.query.isShowTopnofify ||
    //       this.$route.query.isShowTopnofify == "false"
    //     ) {
    //       this.isShowNotify = false;
    //     } else {
    //       this.isShowNotify = true;
    //     }
    //   } else {
    //     this.isShowNotify = this.$route.query.isShowTopnofify;
    //   }
    // }
    // else{
    //   const params = commonAPI.getJsonLocal("onlyonlyreadone");
    //   if( params){
    //     this.year = params.year;
    //     this.quarter = params.quarter;
    //     this.cityCode = params.area;
    //     this.cityName = params.areaName;
    //     this.quarterName = params.year + '年' + this.fixQuater(params.quarter);
    //     this.complainQuarter = params.complainQuarter;
    //     this.showAreaPicker = params.compickFlag;
    //     this.showQuarterPicker = params.compickFlag2;
    //   }
    // }
    // if (this.getData) this.getAssessScoreDay(1, 'A')
    // this.$router.go(0);

    console.log('output->[ activated ] >', this.$router.query)
  },
  deactivated() {

    this.getData = true;
    console.log('----什么时候走这个?deactivated');
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log('to=============-----', from)
      // 通过 `vm` 访问组件实例
      if (from.path === "/appraise/index") {
        vm.getInit();
        // // 一定是从A进到B页面才刷新
        // vm.isProvPriv = to.query.isProvPriv;
        // vm.year = to.query.year;
        // vm.quarter = to.query.quarter;
        // vm.cityCode = to.query.area;
        // vm.cityName = to.query.areaName;
        // vm.quarterName = to.query.quarterName;
        // vm.showAreaPicker = to.query.showAreaPicker;
        // vm.showQuarterPicker = to.query.showQuarterPicker;
        // vm.getAssessScore();
      } else {

      }
    });
  },
};
</script>
<style scoped lang="less">
.card-bg {
  padding-top: 16px;
  padding-bottom: 16px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
  border-radius: 3px;
}

.container {
  min-height: 100vh;
  width: 100%;
  background: rgba(251, 251, 251, 1);
  padding-bottom: 24px;
  overflow-x: hidden;

  .notice-box1 {
    position: relative;
    display: flex;
    align-items: center;
    height: 30px;
    margin-top: 16px;
    background: rgba(245, 245, 245, 1);
    border-radius: 3px;
    box-sizing: border-box;
    padding-left: 16px;
    // margin-bottom: 26px;
    margin-left: 12px;
    margin-right: 12px;

    .left-text {
      font-size: 12px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 30px;
      padding-right: 16px;
      width: 40px;
      margin-right: 16px;
      height: 30px;
      margin-top: 2px;
    }

    .swiper-box {
      width: calc(100% - 40px);
      height: 30px;
    }
  }

  .back-contain {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 999;

    .tap-box {
      margin: 260px 58px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: rgba(255, 255, 255, 1);
      border-radius: 3px;

      .content {
        margin-top: 33px;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 14px;

        .con {
          margin-bottom: 10px;
        }
      }

      .iknow {
        margin-top: 14px;
        width: 228px;
        height: 38px;
        background: rgba(54, 179, 116, 1);
        border-radius: 2px;
        border: 1px solid rgba(54, 179, 116, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 14px;
        margin-bottom: 16px;
      }
    }
  }

  .pg-pd12 {
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 19px;
  }

  .noData-bg {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 100px;
  }

  .prov-total {
    .prov-title {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      margin-top: 24px;
    }

    &-sel {
      display: flex;
      justify-content: space-between;

      .select {
        display: flex;
        align-items: center;
        line-height: 14px;

        span {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: rgba(74, 74, 74, 1);
          padding-right: 4px;
        }

        .select-icon {
          width: 6px;
          height: 4px;
          background: url("../../../assets/image/xiala.png") no-repeat;
          background-size: 6px 4px;
        }
      }

      .search {
        width: 15px;
        height: 15px;
        background: url("../../../assets/image/sousuo.png") no-repeat;
        background-size: 15px 15px;
      }
    }

    .mt20 {
      margin-top: 20px !important;
    }

    .content {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;
      margin-top: 12px;

      &-item {
        display: flex;
        justify-content: center;

        .total {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        .total:nth-child(2) {
          border-left: solid 1px #eeeeee;
        }
      }

      &-item:first-child {
        border-bottom: solid 1px #eeeeee;
      }

      &-item:last-child {
        border-bottom: 0;
      }

      &-pd16 {
        padding-top: 16px;

        .mt0 {
          margin-top: 0;
        }

        .mt13 {
          margin-top: 13px;
        }

        .com-box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 16px;

          &-left {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
          }

          .van-switch {
            border: solid 1px #e4e4e5;
            width: 40px;
            height: 24px;
          }

          .van-switch.van-switch--on {
            border: solid 1px #36b374;
          }

          .van-switch__node {
            box-shadow: none;
            width: 22px;
            height: 22px;
            top: 1px;
            left: 1px;
          }

          .van-switch--on .van-switch__node {
            left: 0;
          }

          &-right {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 12px;

            .icon {
              width: 12px;
              height: 12px;
              margin-left: 4px;
            }
          }
        }
      }

      .time-cont {
        .score-num {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
          padding: 16px 16px 0 16px;
        }

        .score-list {
          margin-top: 8px;

          .score-item {
            padding: 16px;
            border-bottom: solid 1px #eeeeee;

            .tit {
              display: flex;
              justify-content: space-between;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              line-height: 14px;

              .name {
                color: rgba(51, 51, 51, 1);
              }

              .down {
                color: #ff4d4d;
              }
            }

            .txt {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 12px;
              margin-top: 12px;
            }
          }

          .score-item:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}

/deep/ .van-switch {
  width: 40px;
  height: 24px;
}

/deep/ .van-switch__node {
  margin-top: 1px;
  width: 22px;
  height: 22px;
}
</style>
